import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=17624c91"
import script from "./LogsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports